import { Stack, Typography } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import { DIRECTION_TO_LABEL_KEY_MAP } from "Components/Shared/Transactions/transactionsUtils";
import { useResource } from "Translations/Resources";
import type { ViewerTransactionDirection } from "Utils/TransactionUtils";

type Props = {
  direction: ViewerTransactionDirection;
  publicID: string;
  isUnsuccessful: boolean;
};

export const TransactionInfo = ({
  direction,
  publicID,
  isUnsuccessful,
}: Props) => {
  const { t } = useResource();

  const color = isUnsuccessful ? Colors.RedDark : undefined;

  return (
    <Stack gap={0.5} textAlign="left">
      <Typography fontSize="0.875rem" color={color}>
        {t(DIRECTION_TO_LABEL_KEY_MAP[direction])}
      </Typography>
      <Typography fontSize="0.75rem" color={color}>
        {publicID}
      </Typography>
    </Stack>
  );
};
